import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AppView.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AppView.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/core/AppView.vue?vue&type=script&lang=js&
// module id = 81
// module chunks = 32